import React from 'react';
import { useSearchParams } from 'react-router-dom';
import RedirectMessageLayout from '../common-components/RedirectMessageLayout';

const ResetPasswordResponse: React.FC = () => {
  const [searchParams] = useSearchParams();
  const urlParam = searchParams.get("target_url");

  // Decode URL and ensure it's a relative path
  const getDecodedPath = (): string => {
    if (!urlParam) return '/';

    try {
      const decoded = decodeURIComponent(decodeURIComponent(urlParam));
      return decoded.startsWith('/wmlogin/')
        ? decoded.replace('/wmlogin', '')
        : decoded;
    } catch {
      return '/';
    }
  };

  return (
    <RedirectMessageLayout
      title="Reset Password"
      message="Password changed successfully"
      redirectMessage="Signing into WaveMaker Successfully"
      redirectDelay={5000}
      redirectPath={getDecodedPath()}
    />
  );
};

export default ResetPasswordResponse; 